import { useState, useContext } from "react";
import { Navigate, useOutlet, useLocation, Outlet, useParams } from "react-router-dom";
import { Footer } from "../components/Footer";
import { GlobalHeader } from "../components/menu/ProtectedMenuHeader";
import { useAuth } from "../core/AuthProvider";
import ElevationScroll from "../components/ElevationScroll";
import { AppBar, Toolbar } from "@mui/material";

export const ProtectedLayout = () => {
    const outlet = useOutlet();
    const { user } = useAuth()
    let location = useLocation();
    const [selEvent, setSelEvent] = useState("mytest")

    const { event_id } = useParams()
    console.log("------------EVENT_ID", event_id, selEvent)
    if (!user) {
        console.log("NOT USER", !user)
        return <Navigate to={`/login?from=${location.pathname}`} />;
    }

    return (
        <div>

            <ElevationScroll>
                <AppBar sx={{ backgroundColor: '#fff' }}>
                    <GlobalHeader selEvent={selEvent} />
                </AppBar>
            </ElevationScroll>
            <Toolbar />
            {outlet}
            <Footer />
        </div>
    );
};